import { atom } from 'jotai';

export interface FacilityGroupFormState {
  name: string;
  facilityIds: string[];
  defaultFacilityId?: string;
}

const initialState: FacilityGroupFormState = {
  name: '',
  facilityIds: [],
  defaultFacilityId: undefined,
};

export const $facilityGroupForm = atom<FacilityGroupFormState>(initialState);

export const $updateFacilityGroupForm = atom(
  null,
  (get, set, update: Partial<FacilityGroupFormState>) => {
    const currentState = get($facilityGroupForm);
    set($facilityGroupForm, {
      ...currentState,
      ...update,
    });
  },
);

export const $resetFacilityGroupForm = atom(null, (get, set) => {
  set($facilityGroupForm, initialState);
});
